// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"205":"574fe3bf","551":"f08f88f6","617":"415ab232","629":"a6fc9f5f","630":"9a98f920"}[chunkId] + ".chunk.js";
};